import { useReducer } from "react";

import SUBJECTS from "@/admin/constants/AdminConsoleSubjects";

export const FIELDS_ERROR_MESSAGE = {
  firstName: "Enter first name",
  lastName: "Enter last name",
  email: "Enter a valid email",
  role: "Select role",
  lowestGrade: "Select the lowest grade taught",
  highestGrade: "Select the highest grade taught",
  school: "Select the school",
  highestLowerThanLowest:
    "The grade must be equal to or greater than the one selected in the lowest grade taught field",
};

export const FACULTY_ADDER_ACTIONS = {
  SET_USER_SECTION: "FACULTY|SET_USER_SECTION",
  SET_ROLE_SECTION: "FACULTY|SET_ROLE_SECTION",
  SET_STEP: "FACULTY|SET_STEP",
  RESET_STATE: "FACULTY|RESET_STATE",
};

const DEFAULT_STATE = {
  userSection: {
    firstName: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.firstName,
    },
    lastName: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.lastName,
    },
    email: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.email,
    },
    role: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.role,
    },
  },
  roleSection: {
    lowestGrade: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.lowestGrade,
    },
    highestGrade: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.highestGrade,
    },
    sisId: "",
    school: {
      value: "",
      touched: false,
      errorMessage: FIELDS_ERROR_MESSAGE.school,
    },
    isTeacher: null,
    subjects: SUBJECTS.map((subject) => {
      const { id, name } = subject;
      const checked = false;
      return {
        id,
        name,
        checked,
      };
    }),
  },
  step: 1,
};

const facultyAdderReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FACULTY_ADDER_ACTIONS.SET_USER_SECTION:
      return {
        ...state,
        userSection: payload,
      };
    case FACULTY_ADDER_ACTIONS.SET_ROLE_SECTION:
      return {
        ...state,
        roleSection: payload,
      };
    case FACULTY_ADDER_ACTIONS.SET_STEP:
      return {
        ...state,
        step: payload,
      };
    case FACULTY_ADDER_ACTIONS.RESET_STATE:
      return {
        ...DEFAULT_STATE,
        roleSection: {
          ...DEFAULT_STATE.roleSection,
          subjects: SUBJECTS.map((subject) => {
            const { id, name } = subject;
            const checked = false;
            return {
              id,
              name,
              checked,
            };
          }),
        },
      };

    default:
      return state;
  }
};

const useFacultyAdderReducer = () => {
  return useReducer(facultyAdderReducer, DEFAULT_STATE);
};

export default useFacultyAdderReducer;
